if (typeof document !== "undefined") {
  window.__PUBLIC_PATH__ = "/fonts";
}
